// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}

ion-content {
  --padding-start: var(--ion-safe-area-left);
  --padding-end: var(--ion-safe-area-right);
  --padding-bottom: var(--ion-safe-area-bottom);
}

ion-item {
  --ion-safe-area-left: 0px;
  --ion-safe-area-right: 0px;
}

app-drag-and-drop-files {
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
  padding: 10px 0;
  margin: 0 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/popup-settings-graphic-page/popup-settings-graphic-page.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACI;EACI,oCAAA;AACR;;AAIA;EACI,0CAAA;EACA,yCAAA;EACA,6CAAA;AADJ;;AAKA;EACI,yBAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,4CAAA;EACA,eAAA;EACA,cAAA;AAFJ","sourcesContent":["ion-button {\n    height: 30px;\n    width: 30px;\n    --padding-start: 0;\n    --padding-end: 0;\n    flex-shrink: 0;\n\n    ion-icon {\n        color: var(--ion-color-medium-shade);\n    }\n}\n\n// Keep the content clear of the notch in landscape and of the home indicator (no footer in this popup)\nion-content {\n    --padding-start: var(--ion-safe-area-left);\n    --padding-end: var(--ion-safe-area-right);\n    --padding-bottom: var(--ion-safe-area-bottom);\n}\n\n// The item adds the side safe area to its own padding: the content already has it\nion-item {\n    --ion-safe-area-left: 0px;\n    --ion-safe-area-right: 0px;\n}\n\napp-drag-and-drop-files {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.13);\n    padding: 10px 0;\n    margin: 0 16px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
